import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const CONSULT_IMG =
  "https://images.unsplash.com/photo-1672380135241-c024f7fbfa13?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxmaW5hbmNpYWwlMjBjb25zdWx0aW5nJTIwaGFuZHNoYWtlfGVufDB8fHx8MTc4MjEwMjcyM3ww&ixlib=rb-4.1.0&q=85";

const CTABand = () => {
  return (
    <section className="bg-razmek-dark text-white py-24 lg:py-32 relative overflow-hidden">
      <div className="absolute inset-0 opacity-20">
        <img src={CONSULT_IMG} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-razmek-dark/70" />
      </div>
      <div className="relative max-w-[1100px] mx-auto px-6 lg:px-10 text-center">
        <div className="eyebrow text-razmek-gold">Primera consulta sin costo</div>
        <h2 className="font-serif text-5xl md:text-6xl lg:text-7xl mt-6 leading-[1.05]">
          Diseñemos juntos tu
          <br />
          <span className="italic">arquitectura financiera</span>.
        </h2>
        <p className="mt-8 max-w-2xl mx-auto font-sans text-lg text-white/70 leading-relaxed">
          Una sesión de 45 minutos con un asesor patrimonial. Sin compromiso,
          sin presión comercial. Tendrás un diagnóstico claro y una hoja de
          ruta priorizada.
        </p>
        <div className="mt-12 flex flex-wrap items-center justify-center gap-6">
          <Link
            to="/precalificacion"
            className="group inline-flex items-center gap-3 bg-razmek-gold hover:bg-white hover:text-razmek-dark text-white px-8 py-5 font-sans tracking-[0.16em] uppercase text-[11px] border-2 border-razmek-gold transition-all"
          >
            Agendar asesoría
            <ArrowUpRight
              size={16}
              className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
            />
          </Link>
          <a
            href="https://wa.me/5215583570588?text=Hola%20RAZMEK%2C%20me%20interesa%20una%20asesor%C3%ADa"
            target="_blank"
            rel="noreferrer"
            className="link-underline font-sans tracking-[0.16em] uppercase text-[11px] text-white"
          >
            Hablar por WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTABand;
